export default __webpack_public_path__ + "static/media/pokedex-detail-evolution.20da5834.png";